import React from 'react';
import { BaseLayerView } from '@/framework';
import { type IVectorLayerProps } from '@/version-types';
import { type VectorLayerProps } from '../types';
import { checkIsUsingEffect } from '../utils';
import ImageContent from './image-content';
import TextContent from './text-content';

const VectorLayer: React.FC<VectorLayerProps> = ({ layer, identity, isNavigator, onRenderEnd }) => {
    const layerData = layer.data as IVectorLayerProps;
    const hasTextInfo = !!layerData.textInfo;
    const isUsingEffect = checkIsUsingEffect(layerData, { includeBlur: true });

    const textViewStyle: React.CSSProperties = {
        position: 'absolute',
        left: 0,
        top: 0,
        width: '100%',
        height: '100%',
    };

    return (
        <BaseLayerView layer={layer} isNavigator={isNavigator} isOverflowHidden={!isUsingEffect}>
            <ImageContent layer={layer} isNavigator={isNavigator} identity={identity} onRenderEnd={onRenderEnd} />
            {hasTextInfo ? (
                <div data-text-content-id={layer.id} style={textViewStyle}>
                    <TextContent layer={layer} isNavigator={isNavigator} identity={identity} />
                </div>
            ) : null}
        </BaseLayerView>
    );
};

export default VectorLayer;
